import { render } from "./stockAdjustmentApprovalForm.vue?vue&type=template&id=523a4e8a&scoped=true"
import script from "./stockAdjustmentApprovalForm.vue?vue&type=script&lang=js"
export * from "./stockAdjustmentApprovalForm.vue?vue&type=script&lang=js"

import "./stockAdjustmentApprovalForm.vue?vue&type=style&index=0&id=523a4e8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523a4e8a"]])

export default __exports__